<template>
  <market-form
    :marketFormInfo="marketFormInfo"
    :marketFormFieldList="marketFormFieldList"
    @handleSubmit="handleSubmit"
  />
</template>

<script>
import { get, post } from '@/utils/request';
import marketForm from '@/components/marketForm';
import moment from 'moment';

export default {
  components: {
    'market-form': marketForm,
  },
  data: function() {
    return {
      marketFormInfo: '',
      marketFormFieldList: [],
      formData: {},
    };
  },
  mounted: function() {
    const { marketFormNo } = this.$route.params;
    if (!marketFormNo) this.$router.push('/notFound');
    this.initForm(marketFormNo); // 初始化表单
  },
  methods: {
    /**
     * 提交表单
     */
    handleSubmit: function(values) {
      const { marketFormNo, employeeId } = this.$route.params;
      const { sourcePage, productId, courseId } = this.$route.query;
      const postData = {
        marketFormNo: marketFormNo || null,
        sourcePage: sourcePage || null,
        productId: productId || null,
        courseId: courseId || null,
        posterEmployeeId: employeeId || null,
        ...values,
      };
      post('/bp/marketFormItem/saveFormItem', postData).then((res) => {
        const { success } = res || {};
        if (success) {
          const { marketFormNo } = this.$route.params;
          this.$router.push(`/marketFormLandPage/${marketFormNo}`);
        }
      });
    },
    /**
     * 初始化表单
     */
    initForm: function(marketFormNo) {
      get('/bp/marketForm/showForm', {
        marketFormNo,
      }).then((res) => {
        const { success, rows } = res || {};
        if (success) {
          const { marketFormInfo, marketFormFieldList, deadlineDate } =
            rows[0] || {};

          // 当前时间 > 最后可扫码报名日期（当天结束）--则不可提交报名表单
          if (deadlineDate && moment() > moment(deadlineDate).endOf('day')) {
            this.$router.push('/marketFormDeadline');
            return;
          }

          // 生成表单信息
          this.marketFormInfo =
            marketFormInfo && marketFormInfo !== `<p></p>`
              ? marketFormInfo
              : '';
          this.marketFormFieldList = marketFormFieldList || [];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
